export const authQueryKeys = {
  me: (userId?: string | null) => ['auth', 'me', userId ?? 'anon'] as const,
};
